import { Observable, Subscription } from 'rxjs';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { DateService } from './services/date.service';
import { RaceService } from './services/race.service';
import { SettingsService } from './services/settings.service';
import { ProfileService } from './services/profile.service';
import { CommonService } from './services/common.service';
import { ConfirmationService } from 'primeng/api';
import { AttachmentDomainService } from './domains/attachment.service';
import { AuthService } from './services/auth.service';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ConfirmationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnDestroy {
  loading = false;
  showMap = false;
  showDate = true;
  isWidgetMode = false;

  private subscriptions = new Subscription();
  state$: Observable<{ isLoading: boolean; progress: number }> = this.loaderService.state$;

  constructor(
    public raceService: RaceService,
    public appSettings: SettingsService,
    public authService: AuthService,
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private profileService: ProfileService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private confirmationService: ConfirmationService,
    private dateService: DateService,
    private attachmentDomainService: AttachmentDomainService,
  ) {
    // Проверяем, запущено ли приложение в режиме виджета
    this.checkWidgetMode();
    
    this.commonService.confirmEvent.subscribe((confirmation) => {
      this.confirmationService.confirm(confirmation);
    });

    this.subscriptions.add(
      this.raceService.toggleEvent.subscribe((loading) => {
        this.loading = loading;
        this.cdr.markForCheck();
      })
    );

    this.subscriptions.add(
      this.profileService.loadingEvent.subscribe((loading) => {
        this.loading = loading;
        this.cdr.markForCheck();
      })
    );

    this.appSettings.selectedLangSource.next();
    this.loadDocTypes();
  }

  // Проверка режима виджета
  checkWidgetMode() {
    this.route.firstChild?.url.subscribe((segments) => {
      this.isWidgetMode = segments.some(segment => segment.path === 'auth-widget');
      this.cdr.markForCheck();
    });
  }

  loadDocTypes(): void {
    this.attachmentDomainService.getDocTypeList().subscribe((docTypes: any[]) => {
      const otherDocType = { code: '', name: this.appSettings.translate[this.appSettings.selectedLang]['other'] };
      this.appSettings.docTypes = [otherDocType, ...docTypes];
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onMap(): void {
    this.showMap = !this.showMap;
    this.dateService.onShowMapEvent.emit();
  }

  onRaceFilterChange(type: string) {
    this.showDate = type === 'all';
  }

  goToCreateRace() {
    const lang = this.appSettings.selectedLang;
    this.commonService.confirm({
      header: this.appSettings.translate[lang]['create_new'],
      message: this.appSettings.translate[lang]['create_new_race'],
      acceptLabel: this.appSettings.translate[lang]['yes'],
      rejectLabel: this.appSettings.translate[lang]['no'],
      accept: () => {
        this.router.navigate(['race_form/new'], { relativeTo: this.route });
      },
    });
  }
}
